import { Avatar, Box, Container, Divider, Heading, SimpleGrid, Stack, Text, Image, Flex, ButtonGroup, Button, useDisclosure, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter } from "@chakra-ui/react";
import moment from "moment";
import { ReactElement, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import OrderService from "services/orders/order-service";
import Layout from "scenes/layouts";
import Number from "components/number-format";
import PartnerService from "../../../services/partners/partner-service";
import TransferDialog from "./transfer-dialog";
//import OrderPayManualDialog from "./pay-manual";

const RequestWithdrawDetailScene = (): ReactElement => {
    const navigate = useNavigate();
    const { withdrawId } = useParams();
    const [withdraw, setWithdraw] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { isOpen: isShowTransferDialog, onOpen: onShowTransferDialog, onClose: onCloseTransferDialog } = useDisclosure();
    const { isOpen: isShowRejectAlert, onOpen: onShowRejectAlert, onClose: onCloseRejectAlert } = useDisclosure();
    const cancelRejectRef = useRef(null);
    const [isSubmitReject, setIsSubmitReject] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        PartnerService.GetWithdraw(withdrawId).then((res: any) => {
            setWithdraw(res.result);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const handleRefreshData = (withdraw: any) => {
        setWithdraw(withdraw);
        onCloseTransferDialog();
    };

    const handleRejectWithdraw = () => {
        setIsSubmitReject(true);
        PartnerService.RejectRequestWithdraw(withdraw.partner.partnerId, withdraw.id).then((res: any) => {
            setWithdraw(res.result);
            onCloseRejectAlert();
        }).finally(() => {
            setIsSubmitReject(false);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} my={2}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Withdraw {withdraw.partnerName} - {moment(withdraw.requestDate).format("DD MMMM yyyy")}</Heading>
                </Box>
                <Box mt={6}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 5, lg: 8 }}>
                        <Stack direction={'row'} spacing={4} align={'center'} cursor={'pointer'} onClick={() => navigate(`/partners/${withdraw.partner.id}`)}>
                            <Avatar size={"lg"} src={withdraw.partner.user.profilePictureUrl || ''} />
                            <Stack direction={'column'} spacing={0} fontSize={'sm'}>
                                <Text fontWeight={600}>{withdraw.partner.user.fullName}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>{withdraw.partner.user.userName}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>{withdraw.partner.user.phoneNumber}</Text>
                            </Stack>
                        </Stack>
                        <Stack direction={'row'} spacing={4} align={'center'}>
                            <Stack direction={'column'} spacing={0} fontSize={'sm'}>
                                <Text fontWeight={600}>Amount: {String.toFormatSeparator(withdraw.amount)}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Status: {withdraw.statusString}</Text>
                                <Text color={'gray.500'} fontSize={'xs'}>Request Date: {moment(withdraw.requestDate).format("DD MMMM yyyy HH:mm")}</Text>
                            </Stack>
                        </Stack>
                    </SimpleGrid>
                </Box>
                <Divider mt={4} />
                <Box mt={4}>
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 2, lg: 4 }}>
                        <Text>Bank: <strong>{withdraw.bankName}</strong></Text>
                        <Text>Cabang Bank: <strong>{withdraw.bankBranch}</strong></Text>
                        <Text>Nomor Rekening: <strong>{withdraw.accountNumber}</strong></Text>
                        <Text>Nama Rekening: <strong>{withdraw.accountName}</strong></Text>
                        <Text>Total yang harus dibayar: <strong>Rp {String.toFormatSeparator(withdraw.amount)}</strong></Text>
                    </SimpleGrid>
                    <Text mt={{ base: 2, lg: 4 }}>Keterangan: <strong>{withdraw.remarks}</strong></Text>
                </Box>
                <Divider mt={4} />

                {
                    withdraw.status === 20 &&
                    <>
                        <Box mt={4} fontSize={'sm'}>
                            <Text>Tanggal Transfer: <strong>{moment(withdraw.receiptDate).format("DD MMMM yyyy HH:mm")}</strong></Text>
                            <Image height={'200px'} mt={2} src={withdraw.receiptUrl} />
                        </Box>
                        <Divider mt={4} />
                    </>
                }

                <Box mt={4}>
                    <ButtonGroup>
                        <Button variant={'outline'} onClick={() => { navigate(-1); }}>Kembali</Button>
                        {
                            withdraw.status === 10 &&
                            <Button variant={"outline"} onClick={onShowRejectAlert}>Reject</Button>
                        }
                        {
                            withdraw.status === 10 &&
                            <Button onClick={onShowTransferDialog}>Transfer</Button>
                        }
                    </ButtonGroup>
                </Box>
            </Container>
            {
                isShowTransferDialog &&
                <TransferDialog
                    withdraw={withdraw}
                    onClose={onCloseTransferDialog}
                    onRefreshData={handleRefreshData}
                />
            }
            {
                <AlertDialog
                    isOpen={isShowRejectAlert}
                    leastDestructiveRef={cancelRejectRef}
                    onClose={onCloseRejectAlert}
                >
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                                Reject Request Withdraw
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                Apakah Anda yakin ingin Reject Permintaan Penarikan ini? Anda tidak bisa membatalkan tindakan ini setelahnya.
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button ref={cancelRejectRef} variant={'outline'} onClick={onCloseRejectAlert}>
                                    Kembali
                                </Button>
                                <Button colorScheme='red' onClick={handleRejectWithdraw} ml={3} isLoading={isSubmitReject}>
                                    Reject
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            }
        </Layout>
    );
};

export default RequestWithdrawDetailScene;